import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import { SlotImage } from '@/features/designer/components/SlotImage'

export function QuoteBannerSection() {
  const sectionRef = useRef<HTMLElement>(null)
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start'],
  })

  const bgY = useTransform(scrollYProgress, [0, 1], ['-15%', '15%'])
  const bgScale = useTransform(scrollYProgress, [0, 0.5, 1], [1.15, 1.05, 1.15])
  const overlayOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.6, 0.35, 0.6])
  const contentY = useTransform(scrollYProgress, [0, 0.5, 1], [60, 0, -60])
  const contentOpacity = useTransform(scrollYProgress, [0, 0.25, 0.75, 1], [0, 1, 1, 0])
  const leftQuoteX = useTransform(scrollYProgress, [0, 0.5, 1], [-40, 0, -20])
  const rightQuoteX = useTransform(scrollYProgress, [0, 0.5, 1], [40, 0, 20])

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden min-h-[420px] flex items-center border-b"
    >
      <motion.div
        style={{ y: bgY, scale: bgScale }}
        className="absolute inset-0 w-full h-full"
      >
        <SlotImage
          slotKey="homepage-quote"
          className="absolute inset-0 w-full h-full"
          alt="Quote background"
          fallback={
            <div className="absolute inset-0 bg-gradient-to-br from-brand-purple-dim to-brand-purple-light" />
          }
        />
      </motion.div>

      <motion.div
        style={{ opacity: overlayOpacity }}
        className="absolute inset-0 bg-black"
      />

      <div className="relative z-10 w-full">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            style={{ y: contentY, opacity: contentOpacity }}
            className="relative mx-auto max-w-4xl text-center text-brand-white"
          >
            <motion.span
              aria-hidden
              style={{ x: leftQuoteX }}
              className="absolute -left-4 -top-6 sm:-left-10 sm:-top-10 text-brand-white/80 font-serif leading-none select-none text-[8rem] sm:text-[12rem]"
            >
              &ldquo;
            </motion.span>
            <motion.span
              aria-hidden
              style={{ x: rightQuoteX }}
              className="absolute -right-4 -bottom-16 sm:-right-10 sm:-bottom-20 text-brand-white/80 font-serif leading-none select-none text-[8rem] sm:text-[12rem]"
            >
              &rdquo;
            </motion.span>

            <blockquote className="relative px-8 sm:px-16">
              <p className="text-xl sm:text-2xl md:text-3xl font-semibold leading-snug">
                Each film feels like an artistic time capsule, drawing the audience into each
                choreographer&apos;s world in a matter of minutes
              </p>
              <footer className="mt-8 text-base sm:text-lg text-brand-white/90">
                &mdash;Miranda Stuck, Motion by Degrees
              </footer>
            </blockquote>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
